import { ConditionRenderFragment } from '@eluve/fhir-renderer';
import { graphql } from '@eluve/graphql-fhir';

/**
 * FHIR Patient lookup by Eluve patient identifier (the Hasura patient id the
 * profile route carries). Mirrors the profile shell's provisioning query but
 * only needs the id — the conditions card keys everything off the FHIR id.
 */
export const FHIR_PATIENT_ID_QUERY = graphql(`
  query FhirConditionsPatientId($identifier: String!) {
    PatientList(identifier: $identifier, _count: 1) {
      id
    }
  }
`);

/**
 * The patient's conditions, newest first, one bounded page per explicit
 * loadMore (never fetch-all). Selections come from the entity's render
 * fragment so the renderer's display contract stays the single source.
 */
export const PATIENT_CONDITIONS_QUERY = graphql(
  `
    query FhirPatientConditions($patientRef: String!, $offset: Int) {
      ConditionConnection(
        patient: $patientRef
        _count: 100
        _offset: $offset
        _sort: "-recorded-date"
      ) {
        count
        offset
        edges {
          resource {
            ...ConditionRender
          }
        }
      }
    }
  `,
  [ConditionRenderFragment],
);
